export const CILOVA_MISTA = [
  {
    typ: "pitva",
    nazev: "Patologie České Budějovice",
    adresa: "Pražská tř. 2275/108, 370 04 České Budějovice",
  },
  {
    typ: "chladnice",
    nazev: "Chladicí zařízení Český Krumlov",
    adresa: "Hřbitovní 149, 381 01 Český Krumlov",
  },
  {
    typ: "krematorium",
    nazev: "Krematorium České Budějovice",
    adresa: "Pražská tř. 2275/108, 370 04 České Budějovice",
  },
  {
    typ: "krematorium",
    nazev: "Krematorium Tábor",
    adresa: "J. Hory 1735, 390 02 Tábor",
  },
  {
    typ: "krematorium",
    nazev: "Krematorium Jihlava",
    adresa: "Žižkova 1864/93, 586 01 Jihlava",
  },
  {
    typ: "krematorium",
    nazev: "Krematorium Plzeň",
    adresa: "Klatovská tř. 2873/169, 301 00 Plzeň",
  },
  {
    typ: "obrad",
    nazev: "Obřadní síň Český Krumlov",
    adresa: "Hřbitovní 149, 381 01 Český Krumlov",
  },
  {
    typ: "obrad",
    nazev: "Kostel sv. Víta Český Krumlov",
    adresa: "Kostelní, 381 01 Český Krumlov",
  },
  {
    typ: "obrad",
    nazev: "Frymburk",
    adresa: "Náměstí, 382 79 Frymburk",
  },
  {
    typ: "obrad",
    nazev: "Horní Planá",
    adresa: "Náměstí, 382 26 Horní Planá",
  },
  {
    typ: "obrad",
    nazev: "Kaplice",
    adresa: "Náměstí, 382 41 Kaplice",
  }
];
